// extracted by mini-css-extract-plugin
export default {"wrapper":"Skills_wrapper__TXDuL","content_wrapper":"Skills_content_wrapper__QHFcO"};